import React from 'react'
import Box from '@mui/material/Box'
import './loading.css'

import loaderGif from '../../assets/images/loader.gif'
import { Alert, Typography } from '@mui/material'

const Loading = ({ fullScreen, hideText }) => {
  return (
    <Box
      display="flex"
      rowGap={4}
      flexDirection="column"
      className="logoText"
      alignItems="center"
      justifyContent="center"
      minHeight={fullScreen && '100vh'}
    >
      <Box component="img" alt="Logo" src={loaderGif} width="12rem" />
      {!hideText && (
        <Box>
          AmbuNet<span style={{ fontFamily: 'arial' }}>&reg;</span>
        </Box>
      )}
    </Box>
  )
}

const LoadingSmall = () => (
  <Box component="img" alt="Logo" src={loaderGif} width="4rem" />
)

export default Loading
export { LoadingSmall }
